// ---------- Entities -------------
export enum OnboardingStatusStatuses {
  NotStarted = 'onboarding_not_started',
  PreApproved = 'onboarding_pre_approved',
  Approved = 'onboarding_approved',
  Rejected = 'onboarding_rejected',
  Pending = 'onboarding_pending',
  None = 'none',
}

export enum OnboardingStatuses {
  Submitted = 'submitted',
  NotSubmitted = 'not_submitted',
  InAccountManagementReview = 'in_account_management_review',
  InReview = 'in_review',
  Rejected = 'rejected',
  AdditionalInfoRequired = 'additional_info_required',
  Approved = 'approved',
}

export enum OnboardingEntryTypes {
  Contact = 'contact',
  Organization = 'organization',
}

// TODO: change name to a more detailed one
export enum AccountTypes {
  current = 'current',
  term = 'term',
}

export enum ApplicationStatuses {
  InReview = 'in_review',
  InAccountManagementReview = 'in_account_management_review',
  Reviewed = 'reviewed',
}

export enum ClientGroupStatuses {
  Onboarding = 'onboarding',
  InReview = 'in_review',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum ClientGroupUserStatuses {
  Onboarding = 'onboarding',
  ReadyForReview = 'ready_for_review',
  AccountManagementReview = 'in_account_management_review',
  InReview = 'in_review',
  Approved = 'approved',
  Rejected = 'rejected',
  Invited = 'invited',
  Enabled = 'enabled',
  Deactivated = 'deactivated',
  InvitationExpired = 'invitation_expired',
}

export enum ClientGroupReviewStatuses {
  NotReviewed = 'not_reviewed',
  ManagerReview = 'manager_review',
  BusinessReview = 'business_review',
  ComplianceReview = 'compliance_review',
  Reviewed = 'reviewed',
}

export enum OnboardingReviewStatuses {
  ManagerReview = 'manager_review',
  BusinessReview = 'business_review',
  ComplianceReview = 'compliance_review',
}

export enum EntityTypes {
  Legal = 'legal',
  Trader = 'trade',
}

export enum OrganizationAddressTypes {
  RegisteredOffice = 'registered_office',
  BusinessAddress = 'business_address',
  MailingAddress = 'mailing_address',
}

export enum ContactAddressTypes {
  PermanentAddress = 'permanent_address',
  MailingAddress = 'mailing_address',
  ResidentalAddress = 'residential_address',
}

export enum EmailTypes {
  Work = 'work',
  Other = 'other',
  Personal = 'personal',
}

export enum PhoneNumberTypes {
  Home = 'home',
  Work = 'work',
  Mobile = 'mobile',
  Business = 'business',
  Fax = 'fax',
  Other = 'other',
}

export enum SourceTypes {
  Document = 'document',
  Link = 'link',
  String = 'string',
}

export enum AdditionalFieldTypes {
  String = 'string',
  Number = 'number',
  Date = 'date',
  Select = 'select',
  Document = 'document',
  Percentage = 'percentage',
  NotProvided = 'not_provided',
  Form = 'form',
  Boolean = 'boolean',
}

export enum AssociationEntries {
  All = 'all',
  Organization = 'organization',
  Contact = 'contact',
  ClientGroup = 'clientGroup',
  JournalEntry = 'journalEntry',
}

export enum GenderTypes {
  Male = 'male',
  Female = 'female',
}

export enum SourceOfWealthCategories {
  IncomeFromProfession = 'income_from_profession',
  InvestmentIncome = 'investment_income',
  CompanyOwnership = 'company_ownership',
  CompanySale = 'company_sale',
  Inheritance = 'inheritance',
  PropertyRentalIncome = 'property_rental_income',
  PropertySale = 'property_sale',
}

export enum SocialMediaTypes {
  Twitter = 'Twitter',
  LinkedIn = 'LinkedIn',
  Facebook = 'Facebook',
  WebSite = 'website',
}

export enum ComplianceRiskLevelTypes {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export enum AccountUserPermissionTypes {
  ViewOnly = 'view_only',
  InstructTransaction = 'instruct_transaction',
  AuthorizedSignatory = 'authorized_signatory',
}

export enum AdministrationPermissionTypes {
  Admin = 'admin',
  LimitedAdmin = 'limited_admin',
  None = 'none',
  ReadOnly = 'read_only_admin',
}

export enum RelationshipEntryTypes {
  Any = 'any',
  Contact = 'contact',
  Organization = 'organization',
}

export enum RelationshipTrackTypes {
  Parent = 'parent',
  Child = 'child',
}

export enum HearAboutTenetVariants {
  Website = 'website',
  Employee = 'employee',
  Referrer = 'referrer',
  Other = 'other',
}

export enum EntityAgeOptions {
  LessThan18Months = 'lessThan18months',
  Between18and36Months = '18to36months',
  Over36months = 'over36months',
}

export enum NumberOfEmployeesOptions {
  One = '1',
  TwoToNine = '2to9',
  TenToFortyNine = '10to49',
  FiftyToOneNinetyNine = '50to199',
  TwoHundredToFourNinetyNine = '200to499',
  FiveHundredToNineNinetyNine = '500to999',
  OneThousandToFourNineNineNine = '1000to4999',
  FiveThousandToNineNineNineNine = '5000to9999',
  OverTenThousand = 'over10000',
}

export enum NumberOfOfficesOptions {
  One = '1',
  Two = '2',
  Three = '3',
  FourToSix = '4to6',
  SevenToTen = '7to10',
  ElevenToFifteen = '11to15',
  SixteenToTwentyFive = '16to25',
  TwentySixToFortyNine = '26to49',
  OverFifty = 'over50',
}

export enum CustomerOptions {
  Individuals = 'individuals',
  SmallBusiness = 'small_businesses',
  MediumEnterprise = 'medium_enterprises',
  LargeEnterprise = 'large_enterprises',
  PublicSector = 'public_sector',
  Startups = 'startups',
  EducationalInstitutions = 'educational_institutions',
  Charities = 'charities',
  FreelancersContractorsConsultants = 'freelancers_contractors_consultants',
  Other = 'other',
}

export enum SourceOfRevenueOptions {
  ProductSales = 'product_sales',
  ServiceFees = 'service_fees',
  Subscriptions = 'subscriptions',
  Affiliate = 'affiliate',
  LicensingRoyalties = 'licensing_royalties',
  Advertising = 'advertising',
  Commission = 'commission',
  Dividend = 'dividend',
  InterestInvestmentIncome = 'interest_investment_income',
  Other = 'other',
}

export enum AmountOptions {
  Below50 = 'below50k',
  From50to99 = '50kto99k',
  From100to249 = '100kto249k',
  From250to499 = '250kto499k',
  From500to999 = '500kto999k',
  Above1m = 'above1m',
}

export enum TotalTransactionsPerMonthOptions {
  Below50 = 'below50k',
  From50to249 = '50kto249k',
  From250to499 = '250kto499k',
  From500to999 = '500kto999k',
  Above1m = 'above1m',
}

export enum CounterPartyOptions {
  Self = 'self',
  ThirdParty = 'third_party',
}

export enum SourceOfFundingOptions {
  AngelInvestment = 'angel_investment',
  PrivateEquityToLimitedPartners = 'private_equity_or_limited_partners',
  VentureCapitalToAcceleratorToGrowthEquity = 'venture_capital_to_accelerator_to_growth_equity',
  SalesOfTokenAllocation = 'sales_of_token_allocation',
  LoanFunding = 'loan_funding',
  BusinessRevenue = 'business_revenue',
  ParentToHoldingToSubsidiaryCompany = 'parent_to_holding_to_subsidiary_company',
  SelfFunded = 'self_funded',
  Other = 'other',
}

export enum SubIndustryOptions {
  NotApplicable = 'not_applicable',
  BlockchainInfrastructure = 'blockchain_infrastructure',
  VirtualAsset = 'virtual_assets',
  GamingAndMetaverse = 'gaming_and_metaverse',
  Stablecoin = 'stablecoin',
  TokenizationServices = 'tokenization_services',
  NFT = 'nft',
  Cybersecurity = 'cybersecurity',
}

export enum TimeframeOptions {
  Immediately = 'immediately',
  WithinTwoWeeks = 'within_2_weeks',
  WithinOneMonth = 'within_1_month',
  OverOneMonth = 'over_1_month',
  NotSure = 'not_sure',
}

export enum AccountUsePercentageOptions {
  LessThen25 = 'lessThan25',
  From25To50 = '25to50',
  From51to75 = '51to75',
  Over75 = 'over75',
}

export enum VirtualAssetInvolvementOptions {
  Transactions = 'transactions_or_investments',
  WithinProject = 'within_project',
  WithinEcosystem = 'within_ecosystem',
}

export enum PurposeOfBankAccountOptions {
  Payroll = 'payroll',
  OperationToExpenditure = 'operation_to_expenditure',
  VendorToPayments = 'vendor_to_payments',
  CapitalToExpenditure = 'capital_to_expenditure',
  TaxToPayments = 'tax_to_payments',
  ServiceToProviders = 'service_to_providers',
  CashToFlow = 'cash_to_flow',
  LoadToPayments = 'loan_to_payments',
  ClientToProjectToFunds = 'client_to_project_to_funds',
  SavingsToReserves = 'savings_to_reserves',
}

export enum NumberOfTransactionsOptions {
  From0To20 = '0to20',
  From21To40 = '21to40',
  From41To60 = '41to60',
  From61To80 = '61to80',
  From81To100 = '81to100',
  From101to120 = '101to120',
  From121to140 = '121to140',
  From141to160 = '141to160',
  From161to180 = '161to180',
  From181to200 = '181to200',
  Over200 = 'over200',
}

export enum ApplicationCommentsStatus {
  Open = 'Open',
  Resolved = 'Resolved',
}
